import { render, staticRenderFns } from "./GalleryPhotos.vue?vue&type=template&id=e287b510&scoped=true&"
import script from "./GalleryPhotos.vue?vue&type=script&lang=js&"
export * from "./GalleryPhotos.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPhotos.vue?vue&type=style&index=0&id=e287b510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e287b510",
  null
  
)

export default component.exports